import { useState, useEffect } from 'react';
import throttle from '../helpers/throttle';

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0,
    vhUnit: 0,
    vwUnit: 0
  });

  useEffect(() => {
    const handleResize = throttle(() => {
      setWindowSize({
        height: window.innerHeight,
        width: window.innerWidth,
        vhUnit: window.innerHeight * 0.01,
        vwUnit: window.innerWidth * 0.01
      });
    }, 1000);

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

export default useWindowSize;
